import { forwardRef } from 'react';

import { ModalProps } from 'components/Modal';
import { ButtonCross } from 'components/buttons';
import { use100vh } from 'hooks/realHeight';

import { ScModalTemplate, ScModalTemplateProps } from './styled';

interface IPositionCrossButtonProps {
  top: number;
  right: number;
}

interface ModalTemplateProps extends ModalProps, ScModalTemplateProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  isButtonCrossHidden?: React.ReactNode;
  positionCrossButton?: IPositionCrossButtonProps;
  isCrossSquare?: boolean;
}

export const ModalTemplate = forwardRef<HTMLDivElement, ModalTemplateProps>(
  (
    {
      header,
      footer,
      title,
      description,
      settings,
      onClose,
      isButtonCrossHidden = false,
      children,
      positionCrossButton,
      isCrossSquare = true,
      ...props
    },
    ref
  ) => {
    const hasTitleOrDescription = title != null || description != null;

    const isNotBottomMode = settings.mode.type !== 'bottom';

    const isBottomMode = settings.mode.type === 'bottom';

    const isBottomModeWithDescription = description != null && isBottomMode;

    const shouldRenderHeadline =
      isBottomModeWithDescription || (hasTitleOrDescription && isNotBottomMode);

    const isMobile = settings.type === 'mobile';

    const isBackgroundType =
      settings.mode.type === 'background' ||
      settings.mode.type === 'background-custom';

    const height = use100vh();

    const topPosition = positionCrossButton ? positionCrossButton?.top : 12;
    const rigthPosition = positionCrossButton ? positionCrossButton?.right : 12;

    return (
      <ScModalTemplate settings={settings} height={height} {...props}>
        <div ref={ref} className="container">
          {!isButtonCrossHidden && (
            <ButtonCross
              onClick={onClose}
              top={topPosition}
              right={rigthPosition}
              square={isCrossSquare}
              transparent={isMobile && isBackgroundType}
            />
          )}
          {title && isMobile && isBottomMode && (
            <div className="title">{title}</div>
          )}
          <div className="inner">
            {header && <div className="header">{header}</div>}
            <div className="body">
              {shouldRenderHeadline && (
                <div className="headline">
                  {title && isNotBottomMode && (
                    <div className="title">{title}</div>
                  )}
                  {description && (
                    <div className="description">{description}</div>
                  )}
                </div>
              )}
              {children}
            </div>
            {footer && <div className="footer">{footer}</div>}
          </div>
        </div>
      </ScModalTemplate>
    );
  }
);
